import { render, staticRenderFns } from "./IcoAudioContent.vue?vue&type=template&id=0c068e4b"
import script from "./IcoAudioContent.vue?vue&type=script&lang=js"
export * from "./IcoAudioContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports